import ApplicationAdapter from 'lumen/adapters/application';

export default class CentralMappingMarketSubscriptionAdapter extends ApplicationAdapter {
  pathForType(modelName: string): string {
    // This is for calling `query` with `typeKey: 'mapping/market_info'`
    // By default, Ember Data will pluralise the key and call `/mapping/market_infos`.
    // We want to call `/mapping/market_info` instead, so we need to overwrite the path here.
    return modelName;
  }
}
